'use strict';

angular.module('mobile-apps').controller('DataImportFileSelectModalController', [
	'$scope',
	'$stateParams',
	'FileUploader',
	'ALLOWED_IMPORT_FILE_EXTENSIONS',
	'ALLOWED_TM_IMPORT_FILE_EXTENSIONS',
	'$modalInstance',
	'EntryMain',
	'AvailableLanguages',
	function (
		$scope,
		$stateParams,
		FileUploader,
		ALLOWED_IMPORT_FILE_EXTENSIONS,
		ALLOWED_TM_IMPORT_FILE_EXTENSIONS,
		$modalInstance,
		EntryMain,
		AvailableLanguages
	) {

		/**
		 * Close modal
		 */
		$scope.close = function() {
			$modalInstance.dismiss();
		};


		$scope.data = {
			allowedFileExtensions: '.' + ALLOWED_IMPORT_FILE_EXTENSIONS.join(', .'),
			allowedTMFileExtensions: '.' + ALLOWED_TM_IMPORT_FILE_EXTENSIONS.join(', .')
		};

		/**
		 * Initialize the needed data
		 */
		function init() {
			$scope.mobileAppId = $stateParams.mobileAppId;

			EntryMain.loadMobileApp($scope.mobileAppId, false, function(err, mobileApp) {
				$scope.mobileApp = mobileApp;

				var availableLanguages = AvailableLanguages.get();
				if ($stateParams.languageId) {
					$scope.currentLanguageISO = EntryMain.languages[$stateParams.languageId].name;
				} else {
					$scope.currentLanguageISO = mobileApp._baseLanguage.name;
				}
				
				availableLanguages.$promise.then(
					function(){
						$scope.currentLanguageName = availableLanguages[$scope.currentLanguageISO];
					}
				);
			});

			var uploader = $scope.uploader = new FileUploader();

			// FILTERS
			uploader.filters.push({
				name: 'dataFilter',
				fn: function(item) {
					var type = item.name.toLowerCase().slice(item.name.lastIndexOf('.') + 1);

					if ($scope.mobileApp.type === 'tm') {
						return ALLOWED_TM_IMPORT_FILE_EXTENSIONS.indexOf(type) !== -1;
					}

					return ALLOWED_IMPORT_FILE_EXTENSIONS.indexOf(type) !== -1;
				}
			});

			// CALLBACKS
			uploader.onWhenAddingFileFailed = function(item, filter, options) {
				console.info('onWhenAddingFileFailed', item, filter, options);
				$scope.errorMessage = 'The file you tried to upload is currently not supported. Please upload files of the following types: "' + ALLOWED_IMPORT_FILE_EXTENSIONS.join('", "') + '"';

			};
			uploader.onAfterAddingFile = function(fileItem) {
				var returnData = {
					file: fileItem._file
				};

				$modalInstance.close(returnData);
			};

		}

		$scope.tryAgain = function() {
			$scope.errorMessage = '';
			init();
		};


		init();

	}
]);
